module.exports = __webpack_public_path__ + "static/img/v76.acdfa78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v76.png
// module id = F1FA
// module chunks = 1